import "@/App.css";
import "@/i18n";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import { Toaster } from "@/components/ui/sonner";

import PublicLayout from "@/components/PublicLayout";
import AdminLayout from "@/components/AdminLayout";
import ProtectedRoute from "@/components/ProtectedRoute";

import Home from "@/pages/public/Home";
import NewsList from "@/pages/public/NewsList";
import NewsDetail from "@/pages/public/NewsDetail";
import MembersPage from "@/pages/public/MembersPage";
import GalleryPage from "@/pages/public/GalleryPage";
import AlbumDetail from "@/pages/public/AlbumDetail";
import ContactPage from "@/pages/public/ContactPage";
import DonatePage from "@/pages/public/DonatePage";

import Login from "@/pages/admin/Login";
import Dashboard from "@/pages/admin/Dashboard";
import NewsManager from "@/pages/admin/NewsManager";
import NewsEditor from "@/pages/admin/NewsEditor";
import MembersManager from "@/pages/admin/MembersManager";
import GalleryManager from "@/pages/admin/GalleryManager";
import AlbumManager from "@/pages/admin/AlbumManager";
import AdminUsersManager from "@/pages/admin/AdminUsersManager";
import ActivityLog from "@/pages/admin/ActivityLog";
import ContactMessagesAdmin from "@/pages/admin/ContactMessagesAdmin";
import DonateAdmin from "@/pages/admin/DonateAdmin";
import SocialAdmin from "@/pages/admin/SocialAdmin";

function App() {
  return (
    <div className="app-shell">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            {/* Public */}
            <Route element={<PublicLayout />}>
              <Route path="/" element={<Home />} />
              <Route path="/news" element={<NewsList />} />
              <Route path="/news/:id" element={<NewsDetail />} />
              <Route path="/mitglieder" element={<MembersPage />} />
              <Route path="/galerie" element={<GalleryPage />} />
              <Route path="/galerie/:id" element={<AlbumDetail />} />
              <Route path="/kontakt" element={<ContactPage />} />
              <Route path="/spenden" element={<DonatePage />} />
            </Route>

            {/* Admin auth */}
            <Route path="/admin/login" element={<Login />} />

            {/* Admin protected */}
            <Route
              path="/admin"
              element={
                <ProtectedRoute>
                  <AdminLayout />
                </ProtectedRoute>
              }
            >
              <Route index element={<Dashboard />} />
              <Route path="news" element={<NewsManager />} />
              <Route path="news/neu" element={<NewsEditor />} />
              <Route path="news/:id" element={<NewsEditor />} />
              <Route path="mitglieder" element={<MembersManager />} />
              <Route path="galerie" element={<GalleryManager />} />
              <Route path="galerie/:id" element={<AlbumManager />} />
              <Route path="aktivitaet" element={<ActivityLog />} />
              <Route path="nachrichten" element={<ContactMessagesAdmin />} />
              <Route path="spenden" element={<DonateAdmin />} />
              <Route path="social" element={<SocialAdmin />} />
              <Route
                path="administratoren"
                element={
                  <ProtectedRoute requireSuperAdmin>
                    <AdminUsersManager />
                  </ProtectedRoute>
                }
              />
            </Route>

            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
          <Toaster position="top-right" richColors />
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
